import { render } from "./SwiperComponent.vue?vue&type=template&id=09e2ecee&ts=true"
import script from "./SwiperComponent.vue?vue&type=script&lang=ts"
export * from "./SwiperComponent.vue?vue&type=script&lang=ts"

import "swiper/swiper-bundle.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__